import { render, staticRenderFns } from "./choicePapers.vue?vue&type=template&id=e8a3826e&"
import script from "./choicePapers.vue?vue&type=script&lang=js&"
export * from "./choicePapers.vue?vue&type=script&lang=js&"
import style0 from "./choicePapers.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports